export default {
  app: {
    theme: "dark",
    screenPosition: "ltr",
    lang: "en",
    lookup: {
      religion: [],
      issuerType: [],
      roleList: [],
      gender: [],
      bloodTypes: [],
      allergyTypes: [],
      allergySeverity: [],
      maritalStatus: [],
      intervals: [],
      languages: [],
      occupations: [],
      documentCategories: [],
      humanbody: [],
      symptoms: [],
      gqualifiers: [],
      squalifiers: [],
      drug: {
        doseUnits: [],
        forms: [],
        types: [],
      },
      questions: null,
      answers: null,
      hints: [],
      informations: [],
    },
  },
  layout: {
    isSidebarOpened: true,
  },
  user: {
    info: {},
    menu: [],
  },
  auth: {
    status: "",
    renewTokenStatus: "",
    profile: {},
  },
  organization: {
    internalOrgServicePlans: null,
  },
  webRtc: {
    isConnected: null,
    error: "",
    clients: [],
  },
};
